import React from "react";

export default function CreateAssessmentModel({
    children,
    onSubmit,
    modalId,
    dataBackDrop,
    dataKeyboard,
    modalClassName = "",
    dialogClassName = "modal-lg",
    contentClassName = "",
}) {

    return (
        
        <div className={`modal fade ${modalClassName}`.trim()} id={modalId} tabIndex="-1" role="dialog" data-backdrop={dataBackDrop} data-keyboard={dataKeyboard} aria-labelledby="exampleModalLabel" aria-hidden="true" style={{ margin: 0 }}>
            <div className={`modal-dialog ${dialogClassName}`.trim()} role="document">
                <div className={`modal-content ${contentClassName}`.trim()}>
                    
                    <form className="form fv-plugins-bootstrap fv-plugins-framework" onSubmit={onSubmit}>
                        {children}
                    </form>

                </div>
            </div>
        </div>

    )
}
